// extracted by mini-css-extract-plugin
export default {"root":"VxEYBk27uH","root_hasSingleTab":"ifXK0FtxAy","text":"kkqoIOnDgG","suffix":"cUxRMdC1kx","caret":"qRpamJqbLO"};